import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import PopOver from '@bibliocommons/deprecated-base-accessibility-pop-over';
import { Attention } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import { SHELF_AVAILABILITY_SEARCH_LIMIT } from '../../../constants/ShelfConstants';

import './ShelfAvailabilityWarning.scss';

function renderContent() {
  return (
    <div className="pop-over-content">
      <div className="prompt-heading-block">
        <FormattedMessage id="find_available_titles_prompt_heading" tagName="h1" />
      </div>
      <FormattedMessage id="find_available_titles_prompt_desc" />
    </div>
  );
}

function renderTriggerContent() {
  return (
    <div>
      <ScreenReaderMessage>
        <FormattedMessage id="ada_finding_available_titles" />
      </ScreenReaderMessage>
      <div className="pop-over-trigger">
        <Attention />
        <span aria-hidden="true">
          <FormattedMessage id="more_details" />
        </span>
      </div>
    </div>
  );
}

export default function ShelfAvailabilityWarning({ shelfCount }) {
  if (shelfCount > SHELF_AVAILABILITY_SEARCH_LIMIT) {
    return (
      <span className="cp-shelf-availability-warning">
        <PopOver
          href="#shelf-availability-warning"
          triggerKey="shelf-availability-warning"
          dataKey="shelf-availability-warning-pop-over"
          triggerContent={renderTriggerContent()}
        >
          {renderContent()}
        </PopOver>
      </span>
    );
  }

  return null;
}

ShelfAvailabilityWarning.propTypes = {
  shelfCount: PropTypes.number.isRequired
};
